import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [openSections, setOpenSections] = useState({
    description: true,
    details: false,
    delivery: false,
    returns: false,
  });

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link onClick={toTop} to="/shop">
            Back to Shop
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  const toggleSection = (key) => {
    setOpenSections((s) => ({ ...s, [key]: !s[key] }));
  };

  return (
    <div className="product-detail">
      <Header />
      <div className="product-detail__container">
        <div className="gallery">
          <div className="thumbnails">
            {product.images.map((img, idx) => (
              <button
                key={idx}
                className={`thumb ${selectedImage === idx ? "active" : ""}`}
                onClick={() => setImage(idx)}
                aria-label={`Show image ${idx + 1}`}
              >
                <img src={img} alt={`${product.name} ${idx + 1}`} />
              </button>
            ))}
          </div>

          <div className="main-image">
            <img src={product.images[selectedImage]} alt={product.name} />
          </div>
        </div>

        <aside className="summary">
          <div className="brand">boventraix</div>
          <h1 className="product-name">{product.name}</h1>

          <div className="price-block">
            <div className="price">£{parseFloat(product.price).toFixed(2)}</div>
            <div className="old-price">
              £{(parseFloat(product.price) * 1.2).toFixed(2)}
            </div>
            <div className="save">
              Save{" "}
              {100 -
                Math.round(
                  (parseFloat(product.price) /
                    (parseFloat(product.price) * 1.2)) *
                    100
                )}
              %
            </div>
          </div>

          <div className="promo-note">
            Extra 10% Off, with code: <strong>EXTRA</strong>
          </div>

          <div className="delivery-eta">
            Order in <strong>15 hrs 36 mins</strong> for Next Day Delivery
          </div>

          <div className="size-select">
            <div className="size-label">Select a Color:</div>
            <div className="sizes">
              {product.colors.map((s) => (
                <button
                  key={s}
                  className={`size-btn ${selectedColor === s ? "active" : ""}`}
                  onClick={() => setSelectedColor(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <div className="size-select">
            <div className="size-label">Select a Size:</div>
            <div className="sizes">
              {product.size.map((s) => (
                <button
                  key={s}
                  className={`size-btn ${selectedSize === s ? "active" : ""}`}
                  onClick={() => setSelectedSize(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button className="add-to-bag" onClick={handleAddToCart}>
            ADD TO BAG
          </button>

          <div className="delivery-box">
            <div>
              <strong>Delivery from £3.99</strong> or Next Day from £5.99
            </div>
            <div>
              Eligible for return within 28 days — see our{" "}
              <Link onClick={toTop} to="/returns">
                returns policy
              </Link>
            </div>
          </div>

          <div className="handpicked">
            <h4>Handpicked For You</h4>
            <div className="handpicked-grid">
              {productData
                .filter((p) => p.id !== product.id)
                .slice(0, 6)
                .map((p) => (
                  <Link
                    onClick={toTop}
                    key={p.id}
                    to={`/shopDetails/${p.id}`}
                    className="hp-card"
                  >
                    <img src={p.image} alt={p.name} />
                    <div className="hp-meta">
                      <div className="hp-brand">boventraix</div>
                      <div className="hp-title">{p.name}</div>
                      <div className="hp-price">
                        £{parseFloat(p.price).toFixed(2)}
                      </div>
                    </div>
                  </Link>
                ))}
            </div>
          </div>
        </aside>
      </div>

      <div className="detail-panels">
        <div className="at-a-glance">
          <h3>At a Glance</h3>
          <ul className="features-list">
            {product.Features.map((f, i) => (
              <li key={i}>{f}</li>
            ))}
          </ul>
        </div>

        <div className="accordion">
          <button
            className="acc-head"
            onClick={() => toggleSection("description")}
          >
            Description
            <span className="chev">{openSections.description ? "▴" : "▾"}</span>
          </button>
          {openSections.description && (
            <div className="acc-body">
              <ul>
                {product.description.map((d, i) => (
                  <li key={i}>{d}</li>
                ))}
              </ul>
            </div>
          )}

          <button className="acc-head" onClick={() => toggleSection("details")}>
            Product Details & Care
            <span className="chev">{openSections.details ? "▴" : "▾"}</span>
          </button>
          {openSections.details && (
            <div className="acc-body">
              <p>
                <strong>Material:</strong> {product.material}
              </p>
              <p>
                <strong>Colors:</strong> {product.colors.join(", ")}
              </p>
            </div>
          )}

          <button
            className="acc-head"
            onClick={() => toggleSection("delivery")}
          >
            Delivery
            <span className="chev">{openSections.delivery ? "▴" : "▾"}</span>
          </button>
          {openSections.delivery && (
            <div className="acc-body">
              <ul>
                <li>
                  Next Day Delivery — Order by 10pm, 7 days a week — £5.99
                </li>
                <li>UK Express Delivery — Up to 3 Working Days — £4.99</li>
                <li>InPost Delivery — Up to 6 Working Days — £2.49</li>
              </ul>
            </div>
          )}

          <button className="acc-head" onClick={() => toggleSection("returns")}>
            Returns
            <span className="chev">{openSections.returns ? "▴" : "▾"}</span>
          </button>
          {openSections.returns && (
            <div className="acc-body">
              <p>
                Something not quite right? You have 28 days from the day you
                receive it to send something back. Items must be unworn and
                original labels attached.
              </p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ProductDetail;
